<template>
  <es-loader
    v-if="loading"
    style="margin: 15rem"
  />
  <div v-else>
    <div class="modal is-active"
      role="dialog"
      aria-label="Confirm Split ID Decision"
      aria-hidden="false"
      v-if="showModal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Confirm Decision
          </p>
          <button
            class="icon is-right"
            @click.prevent="toggleModal()"
            ref="closeIcon"
          >
            <font-awesome-icon :icon="['fas', 'times']" title="Close"/>
          </button>
        </header>
        <section class="modal-card-body">
          <div class="modal-body">
            Are you sure you want to Split ID?
          <br/>
          <br/>
          </div>
          <div class="update-box">
            <button @click.prevent="toggleModal()"
              class="button button-link has-underline"
            >
              Cancel
            </button>
            <button
              class="button is-primary"
              @click="yesSplitId()"
            >
              Yes Split Id
            </button>
          </div>
        </section>
      </div>
    </div>
    <div v-else>
      <div  class="document">
        <div class="header">
          <es-header>
            <template #header>
              <div class="header-title">
                Review Split ID Confirmation
              </div>
            </template>
          </es-header>
        </div>
        <div style="padding: 1.5rem 1.25rem .5rem 2rem">
          <div class="is-flex flex-justify--space-between" style="margin-bottom: 0.5rem">
            <div class="has-text-weight-bold has-text-left outer">
              Pending Split ID Confirmation
            </div>
          </div>
          <div>
            <div class="table-wrapper">
              <table class="table is-fullwidth is-hoverable">
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      Name
                    </th>
                    <th>
                      Location Info
                    </th>
                    <th v-if="fieldEnabled('DATE_OF_BIRTH')">
                      {{ fieldLabel('DATE_OF_BIRTH') }}
                    </th>
                    <th v-if="fieldEnabled('LOCAL_STUDENT_ID')">
                      {{ fieldLabel('LOCAL_STUDENT_ID') }} Info
                    </th>
                    <th v-if="fieldEnabled('GENDER_CODE')">
                      {{ fieldLabel('GENDER_CODE') }}
                    </th>
                    <th
                      v-if="fieldEnabled('ETHNICITY_INDICATOR')
                        && fieldEnabled('RACE_ETHNIC_CODE')"
                    >
                      {{ fieldLabel('ETHNICITY_INDICATOR') }} / {{ fieldLabel('RACE_ETHNIC_CODE') }}
                    </th>
                    <th
                      v-if="fieldEnabled('ETHNICITY_INDICATOR')
                        && !fieldEnabled('RACE_ETHNIC_CODE')"
                    >
                      {{ fieldLabel('ETHNICITY_INDICATOR') }}
                    </th>
                    <th
                      v-if="!fieldEnabled('ETHNICITY_INDICATOR')
                        && fieldEnabled('RACE_ETHNIC_CODE')"
                    >
                      {{ fieldLabel('RACE_ETHNIC_CODE') }}
                    </th>
                    <th>
                      Last Updated
                    </th>
                    <th>
                      History Record
                    </th>
                    <!-- <th>
                      Notes
                    </th> -->
                    <th>
                      Decision
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="badge" style="background: #5953A4">
                        M
                      </div>
                    </td>
                    <td>
                      {{ data.displayData.retainId.lastName }},
                      {{ data.displayData.retainId.firstName }}
                      <span
                        v-if="data.displayData.retainId.middleName
                          && data.displayData.retainId.middleName !== ''"
                      >
                        {{ data.displayData.retainId.middleName }}
                      </span>
                    </td>
                    <td>
                      {{
                        data.displayData.retainIdLocInfo.districtName
                          ? data.displayData.retainIdLocInfo.districtName
                          : data.displayData.retainIdLocInfo.district.location.name
                      }}
                      <span class="padding-left--small has-text-grey is-italic">
                        ({{ data.displayData.newId.districtCode }})
                      </span>
                      <div>
                        {{
                          data.displayData.retainIdLocInfo.schoolName
                            ? data.displayData.retainIdLocInfo.schoolName
                            : data.displayData.retainIdLocInfo.school.location.name
                        }}
                        <span class="padding-left--small has-text-grey is-italic">
                          ({{ data.displayData.retainId.schoolCode }})
                        </span>
                      </div>
                    </td>
                    <td v-if="fieldEnabled('DATE_OF_BIRTH')">
                      {{ data.displayData.retainId.dateOfBirth | formatDate }}
                    </td>
                    <td v-if="fieldEnabled('LOCAL_STUDENT_ID')">
                      <div style="font-weight: 700">
                        {{ data.displayData.retainId.localId }}
                      </div>
                      <div>
                        {{ mapSource(data.displayData.retainId.sourceCode) }}
                      </div>
                    </td>
                    <td v-if="fieldEnabled('GENDER_CODE')">
                      {{ mapGender(data.displayData.retainId.genderCode) }}
                    </td>
                    <td
                      v-if="fieldEnabled('ETHNICITY_INDICATOR')
                        && fieldEnabled('RACE_ETHNIC_CODE')"
                    >
                      {{ mapEthnicity(data.displayData.retainId.ethnicityIndicator) }}
                      <div>
                        {{ mapRace(data.displayData.retainId.raceEthnicCode) }}
                      </div>
                    </td>
                    <td
                      v-if="fieldEnabled('ETHNICITY_INDICATOR')
                        && !fieldEnabled('RACE_ETHNIC_CODE')"
                    >
                      {{ mapEthnicity(data.displayData.retainId.ethnicityIndicator) }}
                    </td>
                    <td
                      v-if="!fieldEnabled('ETHNICITY_INDICATOR')
                        && fieldEnabled('RACE_ETHNIC_CODE')"
                    >
                      {{ mapRace(data.displayData.retainId.raceEthnicCode) }}
                    </td>
                    <td>
                      {{ data.displayData.retainId.lastUpdateDate | formatDate }}
                    </td>
                    <td>
                      {{ data.displayData.retainIdHistCount }}
                    </td>
                    <!-- <td>
                      {{ data.displayData.retainIdNotesCount }}
                    </td> -->
                    <td>
                      Retain ID ({{ formatStateID(data.retainedId) }})
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="badge" style="background: #428316">
                        M
                      </div>
                    </td>
                    <td>
                      {{ data.displayData.newId.lastName }},
                      {{ data.displayData.newId.firstName }}
                      <span
                        v-if="data.displayData.newId.middleName
                          && data.displayData.newId.middleName !== ''"
                      >
                        {{ data.displayData.newId.middleName }}
                      </span>
                    </td>
                    <td>
                      {{
                        data.displayData.newIdLocInfo.districtName
                          ? data.displayData.newIdLocInfo.districtName
                          : data.displayData.newIdLocInfo.district.location.name
                      }}
                      <span class="padding-left--small has-text-grey is-italic">
                        ({{ data.displayData.newId.districtCode }})
                      </span>
                      <div>
                        {{
                          data.displayData.newIdLocInfo.schoolName
                            ? data.displayData.newIdLocInfo.schoolName
                            : data.displayData.newIdLocInfo.school.location.name
                        }}
                        <span class="padding-left--small has-text-grey is-italic">
                          ({{ data.displayData.newId.schoolCode }})
                        </span>
                      </div>
                    </td>
                    <td v-if="fieldEnabled('DATE_OF_BIRTH')">
                      {{ data.displayData.newId.dateOfBirth | formatDate }}
                    </td>
                    <td v-if="fieldEnabled('LOCAL_STUDENT_ID')">
                      <div style="font-weight: 700">
                        {{ data.displayData.newId.localId }}
                      </div>
                      <div>
                        {{ mapSource(data.displayData.newId.sourceCode) }}
                      </div>
                    </td>
                    <td v-if="fieldEnabled('GENDER_CODE')">
                      {{ mapGender(data.displayData.newId.genderCode) }}
                    </td>
                    <td
                      v-if="fieldEnabled('ETHNICITY_INDICATOR')
                        || fieldEnabled('RACE_ETHNIC_CODE')"
                    >
                      <div v-if="fieldEnabled('ETHNICITY_INDICATOR')">
                        {{ mapEthnicity(data.displayData.newId.ethnicityIndicator) }}
                      </div>
                      <div v-if="fieldEnabled('RACE_ETHNIC_CODE')">
                        {{ mapRace(data.displayData.newId.raceEthnicCode) }}
                      </div>
                    </td>
                    <td>
                      {{ data.displayData.newId.lastUpdateDate | formatDate }}
                    </td>
                    <td>
                      {{ data.displayData.newIdHistCount }}
                    </td>
                    <!-- <td>
                      {{ data.displayData.newIdNotesCount }}
                    </td> -->
                    <td>
                      Create New ID
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="no-border-top">
              <div class="no-bottom-border">
                <es-form style="padding-left: 0rem; margin-left: 0rem">
                  <template #es-form>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">
                            Reason for Split
                          </label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <input
                                type="text"
                                class="input"
                                v-model="reasonForSplit"
                                :class="{ 'is-danger' : hasErrorReasonForSplit }"
                                aria-label="Reason for Split"
                                @input="validateField"
                              >
                            </div>
                            <span
                              v-if="hasErrorReasonForSplit"
                              class="help is-danger"
                            >
                              {{ msgReasonForSplit }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </es-form>
              </div>
            </div>
          </div>
        </div>
        <div
          class="is-flex flex-justify--end flex-align--center user-actions"
          id="bottom-actions"
        >
          <div>
            <button
              class="button button-link has-underline"
              @click="cancel"
              style="width: 60px"
              tabindex="0"
            >
              Cancel
            </button>
            <button
              class="button is-primary"
              style="width: 100px"
              @click="splitIds()"
              ref="btnSplitId"
            >
              Split Id
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons';
import {
  faCaretUp,
  faCaretDown,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowLeftLongToLine,
  faArrowRightLongToLine,
  faPlus,
  faTimes,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import NotificationManager from '@/mixins/NotificationManager';
import StateIdUtils from '@/mixins/StateIdUtils';
import AccessibilityUtils from '@/mixins/AccessibilityUtils';

library.add(
  faArrowLeftLongToLine,
  faArrowRightLongToLine,
  faCaretUp,
  faCaretDown,
  faExclamationTriangle,
  faPlus,
  faTimes,
);

export default {
  mixins: [
    NotificationManager,
    StateIdUtils,
    AccessibilityUtils,
  ],
  components: {
    EsForm,
    EsHeader,
    EsLoader,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return this.initialData();
  },
  computed: {
    ...mapGetters('lookups', [
      'activeEthnicities',
      'activeGenders',
      'activeRaces',
      'activeSources',
      'defaultPersonType',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldLabelByPersonType',
      'getFieldEnabledForPersonType',
    ]),
    requestData() {
      const temp = this.data.requestData;
      temp.splitReason = this.reasonForSplit;
      return temp;
    },
  },
  methods: {
    cancel() {
      this.resetNotifications();
      this.$emit('showSplitIdDetails');
    },
    fieldLabel(code) {
      return this.getFieldLabelByPersonType(code, 'ASSIGN', this.defaultPersonType);
    },
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.defaultPersonType);
    },
    initialData() {
      return {
        hasErrorReasonForSplit: false,
        loading: false,
        msgReasonForSplit: null,
        reasonForSplit: null,
        showModal: false,
      };
    },
    mapEthnicity(ethnicity) {
      const item = this.activeEthnicities.find(e => e.code === ethnicity);
      return item ? item.description : '--';
    },
    mapGender(gender) {
      const item = this.activeGenders.find(r => r.code === gender);
      return item ? item.description : '\u00A0';
    },
    mapRace(race) {
      const item = this.activeRaces.find(r => r.code === race);
      return item ? item.description : '--';
    },
    mapSource(code) {
      const item = this.activeSources.find(s => s.code === code);
      return item ? item.description : '\u00A0';
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    splitIds() {
      this.validateField();
      if (this.hasErrorReasonForSplit) {
        if (!this.reasonForSplit || this.reasonForSplit === null || this.reasonForSplit === '') {
          this.showError('Reason for Split is required.');
        }
        if (this.reasonForSplit && this.reasonForSplit.length > 150) {
          this.showError('Reason for Split allows a maximum of 150 characters.');
        }
      } else {
        this.toggleModal();
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
      this.$nextTick(() => {
        const modalCloseFocus = this.$refs.btnSplitId;
        const modalOpenFocus = this.$refs.closeIcon;
        this.getFocusModal(modalOpenFocus, modalCloseFocus);
      });
    },
    validateField() {
      if (!this.reasonForSplit || this.reasonForSplit === null || this.reasonForSplit === '') {
        this.hasErrorReasonForSplit = true;
        this.msgReasonForSplit = 'Reason for Split is required.';
      } else if (this.reasonForSplit.length > 150) {
        this.hasErrorReasonForSplit = true;
        this.msgReasonForSplit = 'Reason for Split allows a maximum of 150 characters.';
      } else {
        this.hasErrorReasonForSplit = false;
        this.msgReasonForSplit = null;
        this.resetNotifications();
      }
    },
    async yesSplitId() {
      try {
        this.toggleModal();
        this.loading = true;
        this.response = await axios({
          method: 'post',
          url: '/idmanager/split',
          data: this.requestData,
        });
        if (this.response.data.error) {
          this.showError(this.response.data.errorMessage);
          this.loading = false;
        }
        if (!this.response.data.error) {
          const retainedId = (this.response.data.groups.find(a => a.command === 'SPLIT_KEEP_ORIGINAL_ID')).personId;
          const newId = (this.response.data.groups.find(a => a.command === 'SPLIT_GET_NEW_ID')).personId;
          const { splitReason } = this.response.data.reference;
          const splitConfirmed = true;
          this.$router.push({
            name: 'PISplitIdDetails',
            query: {
              stateId: (this.response.data.groups.find(a => a.command === 'SPLIT_KEEP_ORIGINAL_ID')).personId,
            },
            params: {
              newId: (this.response.data.groups.find(a => a.command === 'SPLIT_GET_NEW_ID')).personId,
            },
          });
          this.$emit('viewSplitConfirmationPage', {
            retainedId, newId, splitReason, splitConfirmed,
          });
        }
      } catch (error) {
        this.showError(error.response.data.message);
        this.$emit('loadingError');
      }
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
  table th
    color: #777777
    font-size: 12px
    padding: .1rem .75rem
    border-top: none
  .badge
    min-width: 25px
    border-radius: 50%
    width: 35px
    height: 35px
    padding: 6px
    color: #fff
    text-align: center
    font-size: 1.25rem
    font-weight: 700
  .label
    color: #666666
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
    color: #444
    font-weight: 700
  .outer
    text-align: left
    padding: 1rem 0rem
    margin-left: 0.5rem
    font-size: 13.6px
    font-weight: 700
    color: #212529
  .row
    margin-left: 10px
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
  .user-actions
    margin-right: 1rem
    background: #FFF
    border-top: 1px solid #DEE2E6
    bottom: 0
    color: #F1F1F1
    padding: 10px 16px
    box-shadow: 0 2px 2px 0 #ccc
    position: sticky
  .table-wrapper
    overflow-x: auto
</style>
